var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg0Thersflag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28818",
    "data-name": "Group 28818",
    transform: "translate(-227 -469)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12365",
    "data-name": "Rectangle 12365",
    width: 58,
    height: 44,
    transform: "translate(227 469)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Others",
    transform: "translate(233 495)",
    fontSize: 14,
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Others")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0Thersflag);
export default __webpack_public_path__ + "static/media/0thersflag.6ecaf90910ab9be1e5fbdc69e6b62776.svg";
export { ForwardRef as ReactComponent };